import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { CarouselWithNavigation, InfoBanner } from '@beef/smart-kit';
import { Button, Card, Link } from '@beef/ui-kit';
import { NText } from '@fttb/common/components';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var BannersCarousel = function BannersCarousel(_ref) {
  var bannersData = _ref.bannersData,
    bannersSettings = _ref.bannersSettings,
    _onClick = _ref.onClick,
    pageType = _ref.pageType,
    setCurrentBanner = _ref.setCurrentBanner;
  return /*#__PURE__*/React.createElement(Card, {
    className: cx('slider-banners-wrap'),
    "data-t-id": "components-BannerCarousel"
  }, /*#__PURE__*/React.createElement(CarouselWithNavigation, {
    className: cx('carousel'),
    nextBtnClassname: cx('carousel__btn--next'),
    prevBtnClassname: cx('carousel__btn--prev'),
    sendYm: setCurrentBanner,
    settings: _objectSpread({}, bannersSettings),
    "data-t-id": "components-BannerCarousel"
  }, bannersData.map(function (banner, index) {
    return /*#__PURE__*/React.createElement(InfoBanner, _extends({}, banner, {
      className: cx('banner'),
      key: banner.title
    }), banner.link ? /*#__PURE__*/React.createElement(Link, {
      buttonSize: "l",
      buttonVariant: banner.variant,
      href: banner.link,
      onClick: function onClick() {
        return _onClick({
          index: index,
          link: banner.link,
          pageType: pageType,
          title: banner.title
        });
      },
      target: banner.linkTarget,
      variant: "button"
    }, banner.buttonText) : /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return _onClick({
          index: index,
          pageType: pageType,
          title: banner.title
        });
      },
      size: "l",
      variant: banner.variant
    }, banner.buttonText), bannersSettings.footnote && /*#__PURE__*/React.createElement(NText, {
      className: "mar-t-2xl",
      color: "grey60",
      size: "size6-m"
    }, bannersSettings.footnote));
  })));
};
BannersCarousel.propTypes = process.env.NODE_ENV !== "production" ? {
  bannersData: PropTypes.arrayOf(PropTypes.shape({})),
  bannersSettings: PropTypes.shape({
    autoplay: PropTypes.bool,
    footnote: PropTypes.string,
    loop: PropTypes.bool,
    observeParents: PropTypes.bool,
    observer: PropTypes.bool,
    pagination: PropTypes.shape({
      clickable: PropTypes.string
    }),
    simulateTouch: PropTypes.bool,
    slidesPerView: PropTypes.number
  }),
  onClick: PropTypes.func,
  pageType: PropTypes.string,
  setCurrentBanner: PropTypes.func
} : {};
export { BannersCarousel };